import { AutogenModelMarketActivity, AutogenRowMarketActivity } from "./autogen/AutogenModelMarketActivity";

export class ModelMarketActivity extends AutogenModelMarketActivity<RowMarketActivity> {
	constructor() {
		super(RowMarketActivity);
	}
}

export class RowMarketActivity extends AutogenRowMarketActivity {
}